import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from 'components/ui/dropdown-menu';

import SQLogo from '../../../public/assets/images/StellarQlogo.png';
import { Link } from 'react-router';
import { logOut } from 'utils/fetchers';

const Header = () => {
  return (
    <div className="bg-[url(/public/assets/images/header.png)] bg-cover bg-no-repeat h-20 max-w text-white flex items-center">
      <div className="flex-6">
        <Link to="/">
          <img src={SQLogo} className="w-50 h-auto px-7" />
        </Link>
      </div>
      <div className="flex-6 flex max-w justify-end px-7">
        <DropdownMenu>
          <DropdownMenuTrigger className="cursor-pointer text-lg">Menu</DropdownMenuTrigger>
          <DropdownMenuContent>
            <DropdownMenuItem
              className="cursor-pointer"
              onClick={() =>
                logOut().then(res => {
                  if (res) window.location.assign('/');
                })
              }
            >
              Logout
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
};

export default Header;
